module.exports = __webpack_public_path__ + "static/media/checkbox_unchecked.4a0a9f66.svg";